// extracted by mini-css-extract-plugin
export default {"NutritionPage":"Nutrition_NutritionPage__HdtgP"};